export const classes = {
  base: 'place-center gap-[7px] rounded-[11px] px-4 py-2 text-[13px] transition-[background,border-color,color,filter,opacity] duration-150',
  primary:
    'cursor-pointer bg-grad font-bold text-white hover:brightness-[1.12] hover:saturate-[1.05] dark:bg-grad-dark',
  danger:
    'cursor-pointer bg-[#e5484d] font-bold text-white hover:brightness-[1.12]',
  outline:
    'cursor-pointer border border-hair bg-panel font-semibold text-taupe-3 hover:bg-black/[0.06] dark:border-hair-dark dark:bg-panel-dark dark:text-mauve-1 dark:hover:bg-white/[0.06]',
  disabled:
    'cursor-not-allowed border-transparent bg-black/[0.07] text-taupe-1 shadow-none hover:bg-black/[0.07] hover:brightness-100 hover:saturate-100 dark:bg-white/[0.07] dark:text-mauve-3 dark:hover:bg-white/[0.07]',
  busy: 'cursor-wait opacity-[0.82]',
  spinner:
    'size-[15px] flex-none animate-spinner rounded-full border-2 border-white/40 border-t-white',
};
